export class BasePagingRequest<TFilter>{
    pageIndex: number = 1;
    itemPerPage: number = 10;
    filter?: TFilter;
    export?: boolean = false;
}

/**
 * Başlıktan sıralanabilen liste isteği. Anahtarı arka uç kendi beyaz listesiyle
 * yorumlar; boş ya da tanımadığı anahtarda ucun varsayılan sırası kullanılır.
 */
export class SortablePagingRequest<TFilter> extends BasePagingRequest<TFilter>{
    sortBy?: string | null = null;
    sortDescending?: boolean = false;
}
